export const REASON_REQUEST = "REASON_REQUEST";
export const REASON_NO_RESPONSE = "REASON_NO_RESPONSE";
export const REASON_NO_STUFF = "REASON_NO_STUFF";
export const REASON_RETURN_PACKAGE = "REASON_RETURN_PACKAGE";
export const REASON_ADDRESS_ERROR = "REASON_ADDRESS_ERROR";
export const REASON_DIRECT_RETURN = "REASON_DIRECT_RETURN";
export const REASON_UNHANDLEABLE_CARGO = "REASON_UNHANDLEABLE_CARGO";
export const REASON_CUSTOMER_LOST = "REASON_CUSTOMER_LOST";
export const REASON_ALREADY_PICKED_UP = "REASON_ALREADY_PICKED_UP";
export const REASON_CUSTOMER_DAMAGE = "REASON_CUSTOMER_DAMAGE";
export const REASON_TRANSFERRED_TO_OTHER = "REASON_TRANSFERRED_TO_OTHER";
export const REASON_INACCURATE_RETURN_INSTRUCTION =
  "REASON_INACCURATE_RETURN_INSTRUCTION";
export const REASON_OTHER_CARRIER_PICKUP = "REASON_OTHER_CARRIER_PICKUP";
export const REASON_ETC = "REASON_ETC";

export const CANCEL_REASONS = [
  {
    text: "고객 요청 취소",
    code: REASON_REQUEST,
  },
  {
    text: "2일 3회 전화 실패",
    code: REASON_NO_RESPONSE,
  },
  {
    text: "2회 방문 물품 없음",
    code: REASON_NO_STUFF,
  },
  {
    text: "반품합포장",
    code: REASON_RETURN_PACKAGE,
  },
  {
    text: "수거주소 오류",
    code: REASON_ADDRESS_ERROR,
  },
  {
    text: "고객 직접 반품",
    code: REASON_DIRECT_RETURN,
  },
  {
    text: "취급불가 화물",
    code: REASON_UNHANDLEABLE_CARGO,
  },
  {
    text: "고객분실",
    code: REASON_CUSTOMER_LOST,
  },
  {
    text: "기집하",
    code: REASON_ALREADY_PICKED_UP,
  },
  {
    text: "고객 파손",
    code: REASON_CUSTOMER_DAMAGE,
  },
  {
    text: "타인양도",
    code: REASON_TRANSFERRED_TO_OTHER,
  },
  {
    text: "반품지시부정확",
    code: REASON_INACCURATE_RETURN_INSTRUCTION,
  },
  {
    text: "타 운송사 집하",
    code: REASON_OTHER_CARRIER_PICKUP,
  },
  {
    text: "기타",
    code: REASON_ETC,
  },
];
